export const environment = {
  production: false,
  // Real backend (W2): drafts CRUD/validate/preview + AI-assist hit
  // wg-agents-studio-api. RealAgentBuilderService delegates not-yet-built
  // lifecycle methods (submit/approve/publish/smoke — W4/W5/W6) to the mock.
  // Requires the studio-api drafts endpoints deployed to dev; set true to fall
  // back to the full localStorage mock for offline UI work.
  useMockData: false,
  BASE_URL: 'https://api.agents.dev-wg-agents.com/',
  // New Agent Hub portal (wg-agents-ui). The old portal.dev-wgagenthub.com is retired.
  MAIN_PORTAL_URL: 'https://agents.dev-wg-agents.com',
  PORTAL_LOGIN_URL: 'https://agents.dev-wg-agents.com/login',
  HELP_PORTAL_URL: 'https://help.agents.dev-wg-agents.com',
  STUDIO_API: {
    HEALTH: 'wgagentsstudio/health',
    AGENTS_BASE: 'wgagentsstudio/agents',
    FEEDBACK: 'wgagentsstudio/feedback',
  },
  // Gates for not-yet-shipped surfaces. Flip a flag to true once its feature
  // is ready. See shared/config/feature-flags.ts.
  featureFlags: {
    templateQa: false,
    templateSales: false,
    templateDashboard: false,
    templateCustom: false,
    customLogic: false,
    liveSmokeTest: false,
    teamsDelivery: false,
  },
};
